import { string } from './string'

export const truthy = (value: string | undefined) =>
  'true' === string(value).toLowerCase()
